import { useQuery } from '@tanstack/react-query'
import { fetchExperiment } from './api'

const checkIfActive = (experiment) => {
  return (
    experiment?.experimentType === 'JOIN' &&
    experiment?.isEnabled
  )
}

export const useFetchExperiment = ({ externalId }) => {
  const { data: experiment, isLoading, isRefetching } = useQuery({
    queryKey: ['fetchExperiment', externalId],
    queryFn: async () => {
      await new Promise(resolve => setTimeout(resolve, 300))
      return await fetchExperiment({ externalId })
    },
    enabled: !!externalId,
    retry: 3
  })

  return {
    experiment,
    isLoadingExperiment: isLoading || isRefetching,
    isExperimentActive: checkIfActive(experiment)
  }
}
